import { Box, Button, Tooltip, Typography } from "@mui/material";
import { BOOKING_TYPES, CART_DELV_TYPE } from "constants/general";
import { ROUTES } from "constants/routes";
import moment from "moment";
import ChangePhoneNumber from "pages/list-equipment/ChangePhoneNumber";
import BookingSuccessModal from "pages/payment/success-modal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createBooking } from "slices/bookingReducer";
import cardReducer from "slices/cardReducer";
import { handleSnackBar } from "slices/global";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { clearCartCache, getCartCache } from "utils/cart.util";

const SummaryLineItem = ({ label, value }: any) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Typography
        sx={{
          color: "#A2A2A2",
          fontSize: "20px",
          fontWeight: 500,
          lineHeight: "30px",
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          color: "#323232",
          fontSize: "20px",
          fontWeight: 500,
          lineHeight: "30px",
        }}
      >
        {new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          currencyDisplay: "narrowSymbol",
        }).format(value)}
      </Typography>
    </Box>
  );
};

const BookingSummary = ({ localState }: any) => {
  const cartCache = getCartCache();
  const { cartReducer, bookingReducer, userReducer }: any = useAppSelector(
    (state) => state
  );
  const dispatch = useAppDispatch();
  const cartDelType = cartReducer?.items?.[0]?.delivery_type ?? 0;
  const [showSuccessModel, setShowSuccessModal] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const navigate = useNavigate();

  const bookNow = () => {
    if (!localState.to_date && !localState.from_date) {
      dispatch(
        handleSnackBar({
          open: true,
          message: "Please select the start and end date of your booking.",
          severity: "error",
        })
      );
      return;
    }
    if (!localState.insurance_id) {
      dispatch(
        handleSnackBar({
          open: true,
          message: "Please select insurance for your booking.",
          severity: "error",
        })
      );
      return;
    }

    if (
      !localState.delivery_address_id &&
      cartDelType === CART_DELV_TYPE.DELIVERY
    ) {
      dispatch(
        handleSnackBar({
          open: true,
          message: "Please select delivery address for your booking.",
          severity: "error",
        })
      );
      return;
    }

    if (
      !localState.pickup_address_id &&
      cartDelType === CART_DELV_TYPE.PICKUP
    ) {
      dispatch(
        handleSnackBar({
          open: true,
          message: "Please select delivery address for your booking.",
          severity: "error",
        })
      );
      return;
    }

    const { mobile_number, mobile_number_verified } = userReducer?.userProfile;
    const MobileNo = mobile_number && mobile_number_verified;
    if (!MobileNo) {
      setShowDialog(true);
      return;
    }
    proceedNextToPayment();
  };

  const proceedNextToPayment = () => {
    if (cartReducer?.booking_type === BOOKING_TYPES.MANUAL) {
      const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

      const payload = {
        from_date: moment(cartCache.from_date).format("YYYY-MM-DD"),
        to_date: moment(cartCache.to_date).format("YYYY-MM-DD"),
        ...(cartDelType === CART_DELV_TYPE.PICKUP // If type of pickup then pass delivery address else pass the pickup address
          ? {
              address_id: cartCache.pickup_address_id,
              delivery_address_id: cartCache.pickup_listing_address_id,
            }
          : {
              address_id: cartCache.delivery_address_id,
            }),
        insurance_id: cartCache.insurance_id,
        booking_type: cartReducer.booking_type,
        card_id: 0,
        time_zone: timeZone,
      };

      console.log(payload);
      dispatch(
        createBooking({
          data: payload,
          onSucess: () => {
            setShowSuccessModal(true);
            clearCartCache();
          },
        })
      );
      return;
    }

    navigate(ROUTES.PAYMENT);
  };

  return (
    <Box
      sx={{
        border: "1px solid #E2E2E2",
        borderRadius: "10px",
        padding: "2% 3.5%",

        mt: "25px",
      }}
    >
      <ChangePhoneNumber
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        cb={() => {
          proceedNextToPayment();
          setShowDialog(false);
        }}
      />
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "24px",
          lineHeight: "64px",
          color: "#323232",
          mb: "15px",
        }}
      >
        Cart Summary
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        <SummaryLineItem label="Sub total" value={cartReducer.subtotal} />
        <SummaryLineItem
          label="Haystackers fee"
          value={cartReducer.haystacker_fees}
        />
        <SummaryLineItem label="Insurance" value={cartReducer.insurancePrice} />
        <SummaryLineItem
          label="Security Deposit"
          value={cartReducer.security_deposit}
        />
        <SummaryLineItem label="Taxes" value={cartReducer.taxes} />
        <Box sx={{ height: "1px", background: "#E2E2E2", my: "15px" }} />

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Typography
              sx={{
                color: "#2A2A2A",
                fontSize: "20px",
                fontWeight: 600,
                lineHeight: "30px",
              }}
            >
              Total
            </Typography>
            <Tooltip
              title="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. "
              arrow
            >
              <img src="/assets/img/icons/info_circle.svg" alt="" />
            </Tooltip>
          </Box>
          <Typography
            color="primary"
            sx={{ fontSize: "20px", lineHeight: "30px", fontWeight: 600 }}
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              currencyDisplay: "narrowSymbol",
            }).format(cartReducer.total)}
          </Typography>
        </Box>

        <Box sx={{ my: "15px", display: "flex", gap: "15px" }}>
          <Button
            fullWidth
            size="large"
            variant="outlined"
            sx={{ height: "50px", borderRadius: "10px", padding: 0 }}
            onClick={() => navigate(ROUTES.SEARCH_LISTING)}
          >
            Add More Items
          </Button>
          <Button
            fullWidth
            size="large"
            variant="contained"
            sx={{ height: "50px", borderRadius: "10px", padding: 0 }}
            disabled={bookingReducer.creatingBooking}
            onClick={bookNow}
          >
            Request to Book
          </Button>
        </Box>
      </Box>
      {showSuccessModel && <BookingSuccessModal />}
    </Box>
  );
};

export default BookingSummary;
